module.exports = __webpack_public_path__ + "static/media/4.f3b1bbb6.svg";